export const TRANSLATION = 'builder.resume_distribution.upsell_modal'

export enum Plans {
  CREDITS_10 = '10_credits',
  CREDITS_20 = '20_credits',
  CREDITS_50 = '50_credits',
}
